import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heading: {
    id: 'reassignappointments-modal.heading',
    defaultMessage: 'Re-assign Appointments',
  },
  content: {
    id: 'reassignappointments-modal.content',
    defaultMessage: 'Re-assign appointments that belong to',
  },
  contentTo: {
    id: 'reassignappointments-modal.content.to',
    defaultMessage: 'to',
  },
  subHeading: {
    id: 'reassignappointments-modal.content.subHeading',
    defaultMessage: 'Select appointments to re-assign:',
  },
  subHeadingDescription: {
    id: 'reassignappointments-modal.content.subheading.description',
    defaultMessage: 'Select a staff member above to see their appointments here',
  },
  backButton: {
    id: 'reassignappointments-modal.goback',
    defaultMessage: 'GO BACK',
  },
  noResultsHeading: {
    id: 'reassignappointments-modal.noresults.heading',
    defaultMessage: 'doesn\'t have any appointments scheduled.',
  },
  noResultsContent: {
    id: 'reassignappointments-modal.noresults.content',
    defaultMessage: 'Select a different staff member to see appointments.',
  },
  reassignButton: {
    id: 'reassignappointments-modal.reassign.button',
    defaultMessage: 'REASSIGN APPOINTMENTS',
  },
  sourceStaffErrorMessage: {
    id: 'reassignappointments-modal.reassign.sourceStaffError',
    defaultMessage: 'Please select a Staff Member',
  },
  differentStaffErrorMessage: {
    id: 'reassignappointments-modal.reassign.differentStaffError',
    defaultMessage: 'Please select a different Staff Member',
  },
  targetStaffErrorMessage: {
    id: 'reassignappointments-modal.reassign.targetStaffError',
    defaultMessage: 'Please select a New Assignee',
  },
  sourceTargetNotUniqueErrorMessage: {
    id: 'reassignappointments-modal.reassign.sourceTargetNotUniqueError',
    defaultMessage: 'Can\'t re-assign appointments to the same staff member',
  },
  selectBoxErrorMessage: {
    id: 'reassignappointments-modal.reassign.selectBoxError',
    defaultMessage: 'Please select at least one appointment',
  },
  unexpectedErrorMessageHeading: {
    id: 'reassignappointments-unexpectedErrorMessageHeading',
    defaultMessage: 'There were some errors.',
  },
  unexpectedErrorMessageContent: {
    id: 'reassignappointments-unexpectedErrorMessageContent',
    /* eslint-disable */
    defaultMessage: 'Some appointments couldn\'t be reassigned because of an unexpected error. Please, try again. If the issue persists',
    /* eslint-enable */
  },
  conflictWarningMessage: {
    id: 'reassignappointments-modal.reassign.conflictWarning',
    defaultMessage:
    'RepVisits does not prevent scheduling conflicts. Please confirm availability with the newly assigned rep before proceeding.',
  },
});

export default messages;
